import sample_1 from './olympPilot.jpg';

export const olympPilotImpressions = {
    sample_1,
};
